import styled from 'styled-components'
import { interpointDivider } from 'utilities/styled'

export const Wrapper = styled.div`
    &:not(.compact) {
        margin-block-start: 24px;
    }

    &.interpoint-divider {
        ${interpointDivider()}

        > * {
            display: inline-block;
        }
    }
`

export const Cite = styled.cite`
    font-style: normal;
`

export const Name = styled.span`
    color: var(--huma-color-foreground-default);
`